export class Category {
    public id: number;
    public name: {es: string};
    public slug: {es: string};
    public color: string;
    public icon_class: string;
    public category_id: number;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;


    constructor() {
        this.id = 0;
        this.name = {es: ''};
        this.slug = {es: ''};
        this.color = '';
        this.icon_class = '';
        this.category_id = 0;
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
        
    }
}
